import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    ChartSkeletonDynamicStyleType,
    ChartSkeletonRingConstantType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    CHART_TICK_COUNT
} from "../../util";

export const CHART_SKELETON_BAR_HEIGHTS = [
    0.6,
    0.44,
    0.72,
    0.6,
    0.44,
    0.56,
    0.72,
    0.44,
    0.56,
    0.6
];

export const CHART_SKELETON_GRID_LINES = Array.from({
    length: CHART_TICK_COUNT
}, (_, index) => index / CHART_TICK_COUNT);

export const getChartSkeletonHoleSize = ({
    shapeConfigs,
    kind,
    size
}: ChartSkeletonRingConstantType): number => {
    if(kind === "radial") {
        return Math.max(0, size - shapeConfigs.chartRadialThickness * 2);
    }

    if(kind === "pie") {
        return size * (1 - shapeConfigs.chartDonutRatio);
    }

    return 0;
};

const stylesheet = StyleSheet.create({
    round: {
        justifyContent: "center",
        alignItems: "center"
    },
    bars: {
        alignItems: "flex-end",
        flexDirection: "row"
    },
    container: {
        position: "relative",
        width: "100%"
    },
    area: {
        position: "relative",
        flexGrow: 1
    },
    grid: {
        position: "absolute",
        start: 0,
        end: 0
    },
    hole: {
        position: "absolute"
    },
    bar: {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0
    }
});

export const useStyles = ({
    shapeConfigs,
    surfaceColor,
    radiuses,
    borders,
    colors,
    height,
    spaces,
    kind
}: ChartSkeletonDynamicStyleType) => {
    const styles = {
        hole: {
            backgroundColor: colors.content.container[surfaceColor],
            borderRadius: radiuses.full
        } as Mutable<ViewStyle>,
        plot: {
            borderBottomColor: colors.content.border.subtle,
            borderBottomWidth: borders.line,
            paddingStart: spaces.spacingXl,
            marginBottom: spaces.spacingLg,
            gap: spaces.spacingMd,
            flexGrow: 1
        } as Mutable<ViewStyle>,
        grid: {
            backgroundColor: colors.content.border.subtle,
            height: borders.line
        } as Mutable<ViewStyle>,
        bar: {
            maxWidth: shapeConfigs.chartBarMax
        } as Mutable<ViewStyle>,
        container: {
            height
        } as Mutable<ViewStyle>
    };

    if(kind !== "bars") {
        delete styles.plot.gap;
    }

    if(kind !== "bars" && kind !== "line") {
        Object.assign(styles.plot, {
            paddingVertical: spaces.spacingSm,
            borderBottomWidth: 0,
            marginBottom: 0,
            paddingStart: 0
        });
    }

    return styles;
};
export default stylesheet;
